module.exports = __webpack_public_path__ + "media/identity.df30979c.mp4";